import * as uuid from "uuid"
import moment from "moment"

import { addItemEntityBase, deleteItemEntityBase, getItemEntityBase, getUserFromEmailBase, updateItemEntityBase } from "./firebaseBaseDataUtils.js"
import {
  getFechaCreacionActualizacionObj,
  getFechaActualizacionObj,
  getAniomesActual,
  getAniomesAjuste,
  getKeyFromEmail as getKeyFromEmail_,
} from "./commonUtils.js"
import { crearPagoBase } from "./pagos-commons.js"
// import {
//   susInventarioAccionFerretera,
//   suscripcionesDisponiblesAccionFerretera
// } from "./accionferretera-commons.js"

export const suscripciones_entity = "suscripciones"
export const suscripciones_area = "user-priv-data-read"

export const susPendientes_entity = "suscripciones-pendientes"
export const susPendientes_area = "control-data"

// export const susInventario = susInventarioAccionFerretera

// export const suscripcionesDisponibles = suscripcionesDisponiblesAccionFerretera


//TODO forzar conversión a int de todas las validaciones de vigencias
export const suscripcionVigente = susInfo => susInfo?.fin_aniomes && susInfo.fin_aniomes >= getAniomesActual()
export const suscripcionVencida = susInfo =>  susInfo?.fin_aniomes && susInfo.fin_aniomes < getAniomesActual()
// console.log({aniomesActual})
export const suscripcionVencimientoMes = (susInfo, ajusteMes = 0) => {
  const anioMesAjuste = getAniomesAjuste(ajusteMes)
  return susInfo?.fin_aniomes && susInfo.fin_aniomes == anioMesAjuste
}

// export const validarSuscripcion = codigo => !!suscripcionesDisponibles[codigo]
  // codigo === susInventario.SUSCRIPCION_6_MESES ||
  // codigo === susInventario.SUSCRIPCION_3_MESES ||
  // codigo === susInventario.SUSCRIPCION_1_MES

// export const validarSuscripcionPago = codigo => !suscripcionesDisponibles[codigo]?.gratis 
    // codigo === susInventario.SUSCRIPCION_6_MESES ||
    // codigo === susInventario.SUSCRIPCION_3_MESES

// export const validarSuscripcionGratuita = codigo => !!suscripcionesDisponibles[codigo]?.gratis 

export const validarSuscripcionBase = (susDisps, codigo) => !!susDisps[codigo]
export const validarSuscripcionPagoBase = (susDisps, codigo) => !susDisps[codigo]?.gratis 
export const validarSuscripcionGratuitaBase = (susDisps, codigo) => !!susDisps[codigo]?.gratis 



// export const tieneSuscripcionVencida = (susLst) => tieneSuscripcionVencidaBase(suscripcionesDisponibles, susLst)
// {
//   if(!susLst?.[0]) return false

//   const caducas =  susLst.filter(
//     s =>
//     validarSuscripcion(s.codigo) &&
//     s?.fin_aniomes &&
//     s.fin_aniomes < getAniomesActual()
//   )
//   // console.debug("🚀 ~ file: siteUtils.js:175 ~ tieneSusCatTruperCaduca ~ caducas:", caducas.length)
//   return susLst.length === caducas.length
// }

export const tieneSuscripcionVencidaBase = (susDisps, susLst) => {
  if(!susLst?.[0]) return false

  const caducas =  susLst.filter(
    s =>
    validarSuscripcionBase(susDisps, s.codigo) && suscripcionVencida(s)
    // s?.fin_aniomes &&
    // s.fin_aniomes < getAniomesActual()
  )
  // console.debug("🚀 ~ file: siteUtils.js:175 ~ tieneSusCatTruperCaduca ~ caducas:", caducas.length)
  return susLst.length === caducas.length
}


// export const getSuscripcionVigente = (susLst = []) => getSuscripcionVigenteBase(suscripcionesDisponibles, susLst)
  // susLst.filter(
  //   s =>
  //     validarSuscripcion(s.codigo) &&
  //     s?.fin_aniomes &&
  //     s.fin_aniomes >= getAniomesActual()
  // )?.[0]

export const getSuscripcionVigenteBase = (susDisps, susLst = []) =>
  susLst.filter(
    s =>
      validarSuscripcionBase(susDisps, s.codigo) && suscripcionVigente(s)
      // s?.fin_aniomes &&
      // s.fin_aniomes >= getAniomesActual()
  )?.[0]

// export const getSuscripcionVencimientoMes = (susLst = [], ajusteMes = 0) => getSuscripcionVencimientoMesBase(suscripcionesDisponibles, susLst, ajusteMes)
// {
//   const anioMesAjuste = getAniomesAjuste(ajusteMes)
//   // console.debug(
//   //   "🚀 ~ file: siteUtils.js:38 ~ getSusCatTruperAjuste ~ anioMesAjuste",
//   //   anioMesAjuste
//   // )
//   return susLst.filter(
//     s =>
//       validarSuscripcion(s.codigo) &&
//       s?.fin_aniomes &&
//       s.fin_aniomes == anioMesAjuste
//   )?.[0]
// }
export const getSuscripcionVencimientoMesBase = (susDisps, susLst = [], ajusteMes = 0) => {
  // const anioMesAjuste = getAniomesAjuste(ajusteMes)
  // console.debug(
  //   "🚀 ~ file: siteUtils.js:38 ~ getSusCatTruperAjuste ~ anioMesAjuste",
  //   anioMesAjuste
  // )
  return susLst.filter(
    s =>
      validarSuscripcionBase(susDisps, s.codigo) && suscripcionVencimientoMes(s, ajusteMes)
      // s?.fin_aniomes &&
      // s.fin_aniomes == anioMesAjuste
  )?.[0]
}
  
/* export const getSuscripcion6Meses = (susLst = []) =>
  susLst.filter(
    s => s.codigo === susInventario.SUSCRIPCION_6_MESES
  )?.[0]

export const getSuscripcion3Meses = (susLst = []) =>
  susLst.filter(
    s => s.codigo === susInventario.SUSCRIPCION_3_MESES
  )?.[0]

export const getSuscripcion1Mes = (susLst = []) =>
  susLst.filter(s => s.codigo === susInventario.SUSCRIPCION_1_MES)?.[0] */
  
  



export const getKeyFromEmail = getKeyFromEmail_

export const buscarSuscripcionByEmailBase = async (firebase, siteId, email, options) => {
  const key = getKeyFromEmail(email)
  return await buscarSuscripcionBase(firebase, siteId, key, options)
}

export const buscarSuscripcionBase = async (firebase, siteId, key, options = {}) => {
  const { logItem = true } = options
  try {
    return await getItemEntityBase(
      firebase,
      siteId,
      susPendientes_entity,
      susPendientes_area,
      key,
      {
        includeKey: true,
        logItem
      }
    )
  } catch (error) {
    console.error(error)
  }
}

export const getSucripcionInfoAllByEmailBase = async (
  firebase,
  siteId,
  email
) => {
  const keyMail = getKeyFromEmail(email)
  const susPendiente = await getItemEntityBase(
    firebase,
    siteId,
    susPendientes_entity,
    susPendientes_area,
    keyMail,
    {
      includeKey: true,
    }
  )
  const suscripcion = await getItemEntityBase(
    firebase,
    siteId,
    suscripciones_entity,
    suscripciones_area,
    susPendiente?.["suscripcion-key"],
    {
      includeKey: true,
    }
  )
  const usuarioSus = await getItemEntityBase(
    firebase,
    siteId,
    suscripcion?.["user-uid"] + "/suscripciones",
    "usuarios",
    suscripcion?.key,
    {
      includeKey: true,
    }
  )
  return { susPendiente, suscripcion, usuarioSus }
}

export const crearSuscripcionPendByEmailBase = async (firebase, siteId, email, values, suscripcionInfo, options) => {
  return await crearSuscripcionPendBase(firebase, siteId, getKeyFromEmail(email), values, suscripcionInfo, options)
}

export const crearSuscripcionPendBase = async (firebase, siteId, key, values, suscripcionInfo, options = {}) => {
  const {
    aniomesfin: fin_aniomes,
    aniomesini: inicio_aniomes,
    email,
    suscripcion,
  } = values

  const { logItem = true } = options

  const newData = {
    email,
    // ...suscripcionesDisponibles[suscripcion],
    ...suscripcionInfo,
    inicio_aniomes,
    fin_aniomes,
    ...getFechaCreacionActualizacionObj(),
  }

  const susPend = await buscarSuscripcionBase(firebase, siteId, key, { logItem })
  // await dbRef.set(newData)
  if (!susPend)
    return await addItemEntityBase(
      firebase,
      siteId,
      susPendientes_entity,
      susPendientes_area,
      key,
      newData,
      {
        includeKey: true,
        logItem
      }
    )
}

export const actualizarSuscripcionPendByMailBase = async (firebase, siteId, mail, values, suscripcionInfo, options) => {
  const key = getKeyFromEmail(mail)
  return await actualizarSuscripcionPendBase(firebase, siteId, key, values, suscripcionInfo, options)
}

export const actualizarSuscripcionPendBase = async (firebase, siteId, key, values, suscripcionInfo, options = {}) => {
  const {
    aniomesfin: fin_aniomes,
    aniomesini: inicio_aniomes,
    email,
    suscripcion,
  } = values

  const { logItem = true } = options

  const newData = {
    email,
    // ...suscripcionesDisponibles[suscripcion],
    ...suscripcionInfo,
    inicio_aniomes,
    fin_aniomes,
    ...getFechaActualizacionObj(),
  }

  const susPend = await buscarSuscripcionBase(firebase, siteId, key, {logItem})
  // dbRef.update(newData)
  if (!susPend?.ACTIVO)
    return await updateItemEntityBase(
      firebase,
      siteId,
      susPendientes_entity,
      susPendientes_area,
      key,
      newData,
      {
        includeKey: true,
        logItem
      }
    )
}

export const activarSuscripcionBase = async (firebase, siteId, email, useruid, useremail) => {
  const key = email
    .toLowerCase()
    .split(".")
    .join("_PUNTO_")
    .split("@")
    .join("_AT_")


  const susInfo = await buscarSuscripcionBase(firebase, siteId, key)
  console.log(susInfo)


  if (!susInfo)
    throw Error(`No existe una suscripción asociada al correo [${email}]`)

  if (susInfo.ACTIVO)
    throw Error(
      `El correo [${email}] ya ha sido utilizado anteriormente para activar una suscripción.`
    )

  const fecha_date = new Date()
  const fechaCreaObj = getFechaCreacionActualizacionObj(fecha_date)
  const fechaUpdObj = getFechaActualizacionObj(fecha_date)

  const userInfo = {
    ["uid"]: useruid,
    ["email"]: useremail,
  }

  const susInfoNew = {
    ...susInfo,
    ACTIVO: true,
    ["user-uid"]: useruid,
    ["user-info"]: userInfo,
    key: uuid.v4(),
    ["suscripcion-pendiente-key"]: key,
    ...fechaCreaObj,
  }


  await addItemEntityBase(
    firebase,
    siteId,
    suscripciones_entity,
    suscripciones_area,
    susInfoNew.key,
    susInfoNew,
    {
      includeKey: true,
    }
  )


  await addItemEntityBase(
    firebase,
    siteId,
    useruid + "/suscripciones",
    "usuarios",
    susInfoNew.key,
    susInfoNew,
    {
      includeKey: true,
    }
  )

  const updData = {
    ACTIVO: true,
    ["user-uid"]: useruid,
    ["user-info"]: userInfo,
    ["suscripcion-key"]: susInfoNew.key,
    ...fechaUpdObj,
  }
  await updateItemEntityBase(
    firebase,
    siteId,
    susPendientes_entity,
    susPendientes_area,
    key,
    updData,
    {
      includeKey: true,
    }
  )

  return susInfoNew
}


export const cambiarSuscripcionBase = async (firebase, siteId, email, info, options = {}) => {
  const keyMail = email
    .toLowerCase()
    .split(".")
    .join("_PUNTO_")
    .split("@")
    .join("_AT_")

  const { aniomesini, aniomesfin, suscodigo, susnombre, susdescripcion } = info

  const { logItem = true } = options


  const susPendInfo = await buscarSuscripcionBase(firebase, siteId, keyMail, {logItem})

  if (!susPendInfo)
    throw Error(`No existe una suscripción asociada al correo [${email}]`)


    
  const susKey = susPendInfo["suscripcion-key"]
  console.debug(`🚀 ~ suscripciones-commons.js:399 ~ cambiarSuscripcionBase:`, { susKey, codigo: susPendInfo.codigo })

  if (!susPendInfo.ACTIVO || !susKey)
    throw Error(
      `No existe una suscrición ACTIVA asociada al correo [${email}].`
    )


  const fecha_date = new Date()
  
  const fechaUpdObj = getFechaActualizacionObj(fecha_date)


  const susInfoUpd = {
    ...(aniomesini && aniomesfin
      ? { inicio_aniomes: aniomesini, fin_aniomes: aniomesfin }
      : {}),
    ...(suscodigo && susnombre && susdescripcion
      ? { codigo: suscodigo, nombre: susnombre, descripcion: susdescripcion }
      : {}),
    ...fechaUpdObj,
  }


  const susActualInfo = await getItemEntityBase(
    firebase,
    siteId,
    suscripciones_entity,
    suscripciones_area,
    susKey,
    {
      includeKey: true,
      logItem
    }
  )

  if (!susActualInfo?.["user-uid"])
    throw Error(`No existe una suscripción con key [${susKey}].`)

  const useruid = susActualInfo["user-uid"]

  
  await updateItemEntityBase(
    firebase,
    siteId,
    suscripciones_entity,
    suscripciones_area,
    susKey,
    susInfoUpd,
    {
      includeKey: true,
      logItem
    }
  )


  await updateItemEntityBase(
    firebase,
    siteId,
    useruid + "/suscripciones",
    "usuarios",
    susKey,
    susInfoUpd,
    {
      includeKey: true,
      logItem
    }
  )


  await updateItemEntityBase(
    firebase,
    siteId,
    susPendientes_entity,
    susPendientes_area,
    keyMail,
    susInfoUpd,
    {
      includeKey: true,
      logItem
    }
  )

  return susInfoUpd
}

export const onCheckoutUpdateBase = async (firebase, siteId, email, form_id, susDisps, forms_checkout, props = {}) => {
  let respuesta = { codigo: -1, mensaje: "" }
  let suscripcion
  let user
  let pago

  respuesta.email = email
  respuesta.props = props
  respuesta.form = forms_checkout[form_id]

  if (respuesta.form) {
    const suscripcionInfo = susDisps[respuesta.form.suscripcion]

    respuesta.suscripcion_nombre = suscripcionInfo.nombre
    respuesta.suscripcion_meses = suscripcionInfo.meses

    const aniomesini = moment().format("YYYYMM") * 1
    const values = {
      aniomesfin: getAniomesAjuste(
        suscripcionInfo.meses - 1,
        moment().format("YYYYMM") * 1
      ),
      email: email.toLowerCase(),
      suscripcion: suscripcionInfo.codigo,
    }
    // respuesta.values_aniomesini = aniomesini
    respuesta.values_aniomesfin = values.aniomesfin

    const logItem = false

    let sus = await buscarSuscripcionByEmailBase(firebase, siteId, email.toLowerCase(), { logItem })
    // console.log({ sus })
    respuesta.sus_prev = sus
      ? {
          codigo: sus.codigo,
          ACTIVO: sus.ACTIVO,
          fin_aniomes: sus.fin_aniomes,
          inicio_aniomes: sus.inicio_aniomes,
        }
      : null

    // if (false)
    let sus_new
    if (!sus) {
      sus_new = await crearSuscripcionPendByEmailBase(
        firebase,
        siteId,
        email.toLowerCase(),
        {aniomesini, ...values},
        suscripcionInfo,
        { logItem }
      )
      respuesta.mensaje = "Se creó una nueva suscripción."
      respuesta.operacion = "CREAR"
      suscripcion = sus_new
    } else if (sus.ACTIVO) {
      sus_new = await cambiarSuscripcionBase(
        firebase,
        siteId,
        email.toLowerCase(),
        { aniomesini: sus.inicio_aniomes, ...values },
        { logItem }
      )
      respuesta.mensaje = "Se cambió la suscripción."
      respuesta.operacion = "CAMBIAR"
    } else if (sus) {
      sus_new = await actualizarSuscripcionPendByMailBase(
        firebase,
        siteId,
        email.toLowerCase(),
        { aniomesini: sus.inicio_aniomes, ...values },
        suscripcionInfo,
        {logItem}
      )
      respuesta.mensaje = "Se actualizó la suscripción."
      respuesta.operacion = "ACTUALIZAR"
    }

    respuesta.sus_new_inicio_aniomes = sus_new.inicio_aniomes
    respuesta.sus_new_fin_aniomes = sus_new.fin_aniomes

    if(!suscripcion) suscripcion = await buscarSuscripcionByEmailBase(firebase, siteId, email.toLowerCase())
    user = await getUserFromEmailBase(firebase, email.toLowerCase()).catch(err => console.log(err))
    const pagoInfo = {
        importe: props.amount,
        //props.invoice_created_time, 2026-06-28T21:57:54-0500
        fechaPagoDate: moment(props.invoice_created_time).toDate(),
        nombre: props.first_name || "",
        apellidos: props.last_name || "",
        email,
        telefono: props.mobile_number ,
        producto: props.invoice_invoice_items?.[0]?.name || "",
        origen: props.payment_mode || "",
        tipo: respuesta.operacion == "CREAR" ? "NUEVO" : "RENOVACION",
        origenInfo: props
    }
    pago = await crearPagoBase(firebase, siteId, pagoInfo, user, suscripcion)

    respuesta.codigo = 0
  } else {
    respuesta.codigo = -1
    respuesta.mensaje = `No se encontró el formulario [${form_id}].`
  }
  return {respuesta, suscripcion, user, pago}
}



export const seleccionarEliminarSuscripcionBase = async (firebase, siteId, email) => {
  const key = getKeyFromEmail(email)

  const susPend = await buscarSuscripcionBase(firebase, siteId, key)

  if (!susPend)
    throw new Error(`No existe una suscripción asociada al correo [${email}]`)

  const updData = {
    DELETE: "DELETE",
    ...getFechaActualizacionObj(),
  }

  return await updateItemEntityBase(
    firebase,
    siteId,
    susPendientes_entity,
    susPendientes_area,
    key,
    updData,
    {
      includeKey: true,
    }
  )
}
export const cancelarEliminarSuscripcionBase = async (firebase, siteId, email) => {
  const key = getKeyFromEmail(email)

  const susPend = await buscarSuscripcionBase(firebase, siteId, key)

  if (!susPend)
    throw new Error(`No existe una suscripción asociada al correo [${email}]`)

  await deleteItemEntityBase(
    firebase,
    siteId,
    susPendientes_entity,
    susPendientes_area,
    key + "/DELETE"
  )
}
export const confirmarEliminarSuscripcionBase = async (firebase, siteId, email) => {
  const key = getKeyFromEmail(email)

  const susPend = await buscarSuscripcionBase(firebase, siteId, key)

  if (!susPend)
    throw new Error(`No existe una suscripción asociada al correo [${email}]`)

  if (susPend.DELETE != "DELETE")
    throw new Error(`No se puede eliminar la suscripción [${email}]`)

  if (susPend["suscripcion-key"]) {
    const sus = await getItemEntityBase(
      firebase,
      siteId,
      suscripciones_entity,
      suscripciones_area,
      susPend["suscripcion-key"],
      {
        includeKey: true,
      }
    )
    console.log(susPend["suscripcion-key"], { sus })

    //   const dbRef2 = admin
    //   .database()
    //   .ref(`/app/${siteId}/user-priv-data-read/suscripciones/${susInfoNew.key}`)
    // await dbRef2.set(susInfoNew)

    // const dbRefUsu = admin
    //   .database()
    //   .ref(`/app/${siteId}/usuarios/${useruid}/suscripciones/${susInfoNew.key}`)
    // await dbRefUsu.set(susInfoNew)
    const susUs = await getItemEntityBase(
      firebase,
      siteId,
      sus["user-uid"] + "/suscripciones",
      "usuarios",
      sus.key,
      {
        includeKey: true,
      }
    )
    console.log({ susUs })

    await deleteItemEntityBase(
      firebase,
      siteId,
      suscripciones_entity,
      suscripciones_area,
      sus.key
    )
    await deleteItemEntityBase(
      firebase,
      siteId,
      sus["user-uid"] + "/suscripciones",
      "usuarios",
      sus.key
    )
  }

  await deleteItemEntityBase(firebase, siteId, susPendientes_entity, susPendientes_area, key)
}
